// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6172":"b7a21568","7424":"b7a21568"}[chunkId] + ".chunk.css";
};